module.exports = __webpack_public_path__ + "img/thumb_11.57cf7a2a.jpg";